import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

interface IContainerProps {
  width: number;
  currentStep: number;
}

export const Container = styled.div<IContainerProps>`
  width: 100%;

  animation: ${fadeIn} 0.3s ease-in;

  > div {
    display: flex;

    transition: transform 0.3s ease-in;

    width: ${({ width }) => width * 4}px;
    transform: ${({ width, currentStep }) =>
      `translateX(-${width * (currentStep - 1)}px)`};

    > form {
      width: ${({ width }) => width}px;
    }
  }
`;
